<template>
<v-dialog v-model="dialog" width="920" max-height="600" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
        <v-card-title class="headline">
            Organization Details
            <v-spacer />
            <v-btn icon @click="emitExit()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" md="6">
                    <div class="important px-1">Basic informations</div>
                    <v-row no-gutters class="pa-2 regular">
                        <v-row no-gutters>
                            <v-col cols="3" md="2">
                                <v-avatar size="50" class="mx-2">
                                    <img v-if="item.avatar" :src="item.avatar">
                                    <v-icon v-else size="50">face</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8" md="10">
                                <v-row no-gutters fill-height align-center>
                                    <v-col cols="4">ID:</v-col>
                                    <v-col cols="8">{{ item.id }}</v-col>
                                    <v-col cols="4">Name:</v-col>
                                    <v-col cols="8">{{ item.name }}</v-col>
                                    <v-col cols="4">About:</v-col>
                                    <v-col cols="8">
                                        <span v-if="item.about">{{ item.about }}</span>
                                        <span v-else class="font-italic">No info to show</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="important px-1">Contact person</div>
                    <v-row no-gutters class="pa-2 regular">
                        <v-row no-gutters v-if="item.contact">
                            <v-col cols="4">Name:</v-col>
                            <v-col cols="8">
                                <span v-if="item.contact && item.contact.name">{{ item.contact.name }}</span>
                                <span v-else> - </span>
                            </v-col>
                            <v-col cols="4">Type:</v-col>
                            <v-col cols="8" class="text-capitalize">
                                <span v-if="item.contact.position">{{ item.contact.position }}</span>
                                <span v-else> - </span>
                            </v-col>
                            <v-col cols="4">Email:</v-col>
                            <v-col cols="8" class="text-capitalize">
                                <span v-if="item.contact.email">{{ item.contact.email }}</span>
                                <span v-else> - </span>
                            </v-col>
                            <v-col cols="4">Phone:</v-col>
                            <v-col cols="8" class="text-capitalize">
                                <span v-if="item.contact.phone">{{ item.contact.phone }}</span>
                                <span v-else> - </span>
                            </v-col>
                        </v-row>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider class="my-2" />

            <div class="important px-1">Contact info</div>
            <v-row no-gutters class="pa-2">
                <v-col cols="12" md="6" class="regular">
                    <v-row no-gutters>
                        <v-col cols="4">Address:</v-col>
                        <v-col cols="8">
                            <div v-if="item.address && (item.address.street && item.address.building && item.address.number && item.address.city && item.address.region)">
                                <span v-if="item.address.street">{{ item.address.street }}, </span>
                                <span v-if="item.address.street">{{ item.address.building }}, </span>
                                <span v-if="item.address.street">{{ item.address.number }}, </span>
                                <span v-if="item.address.street">{{ item.address.city }}, </span>
                                <span v-if="item.address.street">{{ item.address.region }}, </span>
                                <span v-if="item.address.street">{{ item.address.country }}</span>
                            </div>
                            <div v-else>No info to show</div>
                        </v-col>
                        <v-col cols="4">Email:</v-col>
                        <v-col cols="8">{{ item.email }}</v-col>
                        <v-col cols="4">Phone:</v-col>
                        <v-col cols="8">
                            <span v-if="item.phone">{{ item.phone }}</span>
                            <span v-else> - </span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="6" class="regular">
                    <v-row no-gutters>
                        <v-col cols="4">Website:</v-col>
                        <v-col cols="8">
                            <span v-if="item.website">{{ item.website }}</span>
                            <span v-else> - </span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters align-center :fill-height="item.social.facebook && item.social.instagram && item.social.twitter && item.social.linkedin && item.social.youtube && item.social.google_plus && item.social.tumblr && item.social.pinterest">
                        <v-col cols="4">Social:</v-col>
                        <v-col cols="8">
                            <v-row no-gutters v-if="item.social.facebook && item.social.instagram && item.social.twitter && item.social.linkedin && item.social.youtube && item.social.google_plus && item.social.tumblr && item.social.pinterest">
                                <img v-if="item.social.facebook" src="../../../assets/facebook.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.facebook)">
                                <img v-if="item.social.instagram" src="../../../assets/instagram.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.instagram)">
                                <img v-if="item.social.twitter" src="../../../assets/twitter.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.twitter)">
                                <img v-if="item.social.linkedin" src="../../../assets/linkedin.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.linkedin)">
                                <img v-if="item.social.youtube" src="../../../assets/youtube.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.youtube)">
                                <img v-if="item.social.google_plus" src="../../../assets/google_plus.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.google_plus)">
                                <img v-if="item.social.tumblr" src="../../../assets/tumblr.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.tumblr)">
                                <img v-if="item.social.pinterest" src="../../../assets/pinterest.svg" height="30px" width="30px" class="ma-1 pointer" @click="gotoSocial(item.social.pinterest)">
                            </v-row>
                            <div v-else>No social media added</div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider class="my-2" />
            <v-row no-gutters>
                <v-col cols="12" md="6">
                    <div class="important px-1">Parent Organization</div>
                    <v-row no-gutters class="pa-2 regular" v-if="item.parent_id">
                        <v-row no-gutters>
                            <v-col cols="4">ID:</v-col>
                            <v-col cols="8">{{ parent.id }}</v-col>
                            <v-col cols="4">Name:</v-col>
                            <v-col cols="8">{{ parent.name }}</v-col>
                            <v-col cols="4">Type:</v-col>
                            <v-col cols="8" class="text-capitalize">{{ parent.type }}</v-col>
                            <v-col cols="4">About:</v-col>
                            <v-col cols="8">{{ parent.about }}</v-col>
                        </v-row>
                    </v-row>
                    <v-layout v-else class="regular pa-2 orange--text">
                        The organization isn't linked to another organization
                    </v-layout>
                </v-col>
                <v-col cols="12" md="6">
                    <div class="important px-1">Biling details</div>
                    <v-row no-gutters class="pa-2 regular" v-if="billing.id">
                        <v-row no-gutters>
                            <v-col cols="4">Name:</v-col>
                            <v-col cols="8">{{ billing.name }}</v-col>
                            <v-col cols="4">Email:</v-col>
                            <v-col cols="8">{{ billing.email }}</v-col>
                            <v-col cols="4">Type:</v-col>
                            <v-col cols="8">{{ billing.type }}</v-col>
                            <v-col cols="4">Registry number:</v-col>
                            <v-col cols="8">{{ billing.registry_number }}</v-col>
                            <v-col cols="4">Fiscal code:</v-col>
                            <v-col cols="8">{{ billing.fiscal_code }}</v-col>
                        </v-row>
                        <v-col cols="4">Banks :</v-col>
                        <v-col cols="8">
                            <div v-for="(bank, index) in billing.banks" :key="index">
                                <div>{{ bank.name }}</div>
                                <div>{{ bank.account }} <span class="px-2">{{ bank.currency}}</span></div>
                            </div>
                        </v-col>
                        <v-col cols="4">Contact person :</v-col>
                        <v-col cols="8">
                            <div>{{ billing.contact.name }}</div>
                            <div>{{ billing.contact.postion }}</div>
                            <div>{{ billing.contact.email }}</div>
                            <div>{{ billing.contact.phone }}</div>
                        </v-col>
                    </v-row>
                    <div v-else class="regular pa-2 orange--text">
                        The organization hasn't a billing profile
                    </div>
                    <v-row no-gutters>
                        <v-btn v-if="billing.id" color="red" outlined dark @click="delete_bill_dialog = true">Delete Bill</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" outlined @click="openBillingModal()">
                            <span v-if="billing.id">Edit bill</span>
                            <span v-else>Add bill</span>
                        </v-btn>
                    </v-row>

                    <im-bill-modal :dialog="dialog_bill" :billing_id="billing_id" :organization_id="item.id" :organization_name="item.name" @refresh="getBilling()" @exit="dialog_bill=false,billing_id=null"></im-bill-modal>
                    <!-- delete bill dialog -->
                    <v-dialog v-model="delete_bill_dialog" max-width="320px" persistent>
                        <v-card>
                            <v-card-text class="pt-2">
                                Are you sure you want to delete this billing profile?
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="delete_bill_dialog=false">Cancel</v-btn>
                                <v-btn dark color="red" @click="destroyBill()">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <!-- ./delete bill dialog -->

                </v-col>
            </v-row>

            <v-divider class="my-2" />
            <im-users :organization_id="item.id"></im-users>

        </v-card-text>
        <v-card-actions>
            <v-btn dark class="mx-1" color="red" :outlined="$vuetify.breakpoint.smAndUp" @click="delete_dialog=true" :icon="$vuetify.breakpoint.xs" :text="$vuetify.breakpoint.xs">
                <span v-if="$vuetify.breakpoint.smAndUp">Delete</span>
                <v-icon v-else>delete</v-icon>
            </v-btn>

            <!--delete dialog-->
            <v-dialog v-model="delete_dialog" max-width="320">
                <v-card>
                    <v-card-text class="pt-3">
                        Are you sure you want to delete this organization?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="delete_dialog=false">Cancel</v-btn>
                        <v-btn dark color="red" :loading="loading_delete" @click="destroy()">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--./delete dialog -->


            <v-spacer></v-spacer>
            <v-btn class="mx-1" color="primary" outlined @click="child_dialog=true" :small="$vuetify.breakpoint.xs">
                <span v-if="$vuetify.breakpoint.smAndUp">Add child</span>
                <v-layout v-else row fill-height align-center>
                    <v-icon>add</v-icon>
                    <div>Child</div>
                </v-layout>
            </v-btn>

            <im-add-child :dialog="child_dialog" :organization_id="item.id" :organization_name="item.name" @exit="child_dialog=false"></im-add-child>

            <v-btn class="mx-1" color="primary" :outlined="$vuetify.breakpoint.smAndUp" @click="emitEdit()" :icon="$vuetify.breakpoint.xs" :text="$vuetify.breakpoint.xs">
                <span v-if="$vuetify.breakpoint.smAndUp">Edit</span>
                <v-icon v-else>edit</v-icon>
            </v-btn>
            <v-btn text class="mx-1" @click="emitExit()" :small="$vuetify.breakpoint.xs">Exit</v-btn>
        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import IMUsers from "./UserTableCrud.vue";
import IMBillModal from "./BillModal.vue";
import IMAddChildModal from "./AddChildModal.vue";

export default {
    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        item_id: [Number, String],
    },
    components: {
        'im-users': IMUsers,
        'im-bill-modal': IMBillModal,
        'im-add-child': IMAddChildModal,
    },
    data() {
        return {
            // test values
            loading: true,
            loading_delete: false,
            dialog_bill: false,
            billing_id: null,
            delete_dialog: false,
            child: {},
            add_bill_dialog: false,
            delete_bill_dialog: false,
            child_dialog: false,

            service: {},
            billing: this.$clone(defaults.billing_item),
            item: this.$clone(defaults.organization_item),
            parent: this.$clone(defaults.organization_item),

        }
    },

    watch: {
        item_id: {
            handler() {
                this.billing = this.$clone(defaults.billing_item);
                this.parent = this.$clone(defaults.organization_item);
                this.getItem();
                this.getBilling();
            }
        },
    },

    created() {
        this.getItem();
        this.getBilling();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        // oraganizations functions
        getItem() {
            if(!this.item_id) {
                this.$emit('exit');
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations/';

            this.$axios.get(endpoint + this.item_id)
                .then(response => {
                    this.item = response.data;
                    if(response.data.parent_id) {
                        this.getParentOrganization(response.data.parent_id)
                    }
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
        },

        getParentOrganization(id) {

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations/';

            this.$axios.get(endpoint + id)
                .then(response => {
                    this.parent = response.data;
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
        },

        gotoSocial(url) {
            if((url.indexOf("http://") === -1) && (url.indexOf("https://") === -1)) {
                url = "http://" + url;
            }
            window.open(url);
        },

        // billing functions
        openBillingModal() {
            if(this.billing.id) {
                this.billing_id = this.billing.id;
            } else {
                this.billing_id = null;
            }
            this.dialog_bill = true;
        },

        getBilling() {
            if(!this.item_id) {
                return
            }
            // construct params object
            let params = {
                params: {
                    owner_ids: [this.item_id],
                    owner_types: ["organization"],
                }
            };
            // prepare endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.data[0]) {
                        this.billing = response.data.data[0];
                    } else {
                        this.billing = this.$clone(defaults.billing_item)
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
        },

        destroyBill() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/billings";

            // call delete endpoint
            this.$axios.delete(endpoint + "/" + this.billing.id) // eslint-disable-next-line
                .then(response => {
                    this.getBilling();
                    this.success("Billing profile deleted.");
                    this.delete_bill_dialog = false;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.error(error);
                })
                .finally(() => {});
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations';

            // call delete endpoint
            this.$axios.delete(endpoint + '/' + this.item.id) // eslint-disable-next-line
                .then(response => {
                    this.delete_dialog = false;
                    this.$emit('refresh')
                    this.emitExit();
                    this.success('Organization deleted.');
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.error(error);
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        emitExit() {
            this.$emit('exit');
        },

        emitEdit() {
            this.$emit('edit', this.item.id);
        },

    }
}
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
